export const truncateMiddle = (value: string, maxLength: number): string => {
	if (value.length <= maxLength) {
		return value;
	}

	const availableLength = maxLength - 3;
	const startLength = Math.ceil(availableLength / 2);
	const endLength = Math.floor(availableLength / 2);

	return `${value.slice(0, startLength)}...${value.slice(-endLength)}`;
};
